module.exports = __webpack_public_path__ + "img/flavorites-laptop.69e006ef.gif";